import axios from "axios";
import { toast } from "react-toastify";
import { categorizeNotification } from "./dateUtils";
import moment from "moment";
import "moment/locale/ar"; // Import Arabic locale
export const errorHandler = (error) => {
    const { request, response } = error;
    if (response) {
        const { message } = response.data;
        const status = response.status;
        return { msg: message, status };
    } else if (request) {
        if (axios.isCancel(error)) {
            return { msg: error.message, status: error.status };
        }
        return { msg: "server time out", status: 503 };
    } else {
        return { msg: "opps! something went wrong while setting up request" };
    }
};

export const config = { headers: { "Content-Type": "application/json" } };
export const configMultipart = {
    headers: { "Content-Type": "multipart/form-data" },
};

export const errToast = (err) => {
    if (!err || sessionStorage.getItem("inactiveUser") || sessionStorage.getItem("sessionExpired")) return;
    toast.error(
        sessionStorage.getItem("i18nextLng") === "en"
            ? "Error processing request. Please try again or contact our technical support team."
            : "حدث خطأ أثناء معالجة الطلب. يُرجى المحاولة مجددًا أو التواصل مع فريق الدعم الفني.",
        {
            toastId: "Error Processing Request.",
        }
    );
};

export const sleep = (delay) =>
    new Promise((resolve) => setTimeout(resolve, delay));

export const generateLabel = (dateStr, minCond = false) => {
    const now = moment.utc();

    const date = moment.utc(dateStr);

    if (minCond) {
        const diffSeconds = now.diff(date, "seconds");
        if (diffSeconds < 10) return "now";
        if (diffSeconds < 60) return `${diffSeconds} second${diffSeconds > 1 ? "s" : ""} ago`;

        const diffMinutes = now.diff(date, "minutes");
        if (diffMinutes < 60)
            return `${diffMinutes} minute${diffMinutes > 1 ? "s" : ""} ago`;

        const diffHours = now.diff(date, "hours");
        if (diffHours < 24)
            return `${diffHours} hour${diffHours > 1 ? "s" : ""} ago`;
    }

    if (now.isSame(date, "day")) return "Today";
    if (now.clone().subtract(1, "day").isSame(date, "day")) return "Yesterday";

    const diffYears = now.diff(date, "years");
    if (diffYears >= 1)
        return `${diffYears} year${diffYears > 1 ? "s" : ""} ago`;

    const diffMonths = now.diff(date, "months");
    if (diffMonths >= 1)
        return `${diffMonths} month${diffMonths > 1 ? "s" : ""} ago`;

    const diffWeeks = now.diff(date, "weeks");
    if (diffWeeks >= 1)
        return `${diffWeeks} week${diffWeeks > 1 ? "s" : ""} ago`;

    const diffDays = now.diff(date, "days");
    if (diffDays >= 1) return `${diffDays} day${diffDays > 1 ? "s" : ""} ago`;

    return date.fromNow(); // fallback like "a few seconds ago"
};

export const groupNotificationByDate = (
    notifications,
    date_key = "added_on"
) => {
    return notifications.reduce((acc, notification) => {
        const label = generateLabel(notification[date_key]);
        if (!acc[label]) acc[label] = [];
        acc[label].push(notification);
        return acc;
    }, {});
};

export const removeQueryParam = (param) => {
    const url = new URL(window.location.href);
    url.searchParams.delete(param);

    let newUrl = url.origin + url.pathname;
    if (newUrl.endsWith("/") && newUrl !== url.origin) {
        newUrl = newUrl.slice(0, -1);
    }
    window.history.replaceState({}, "", newUrl);
};

export const formatChatTime = (date, userList, locale = "en") => {
    moment.locale(locale); // Set the locale

    const now = moment();
    const messageDate = moment(date);

    const timeFormat = "h:mm A";
    const userListDateFormat = `DD MMM YYYY`;
    const chatDateTimeFormat = `DD MMM YYYY, ${timeFormat}`;
    const dayTimeFormat = `dddd, ${timeFormat}`;

    const translatedYesterday = locale === "ar" ? "أمس" : "Yesterday";

    if (now.isSame(messageDate, "day")) {
        return messageDate.format(timeFormat);
    } else if (now.clone().subtract(1, "days").isSame(messageDate, "day")) {
        return `${translatedYesterday}${userList ? "" : `, ${messageDate.format(timeFormat)}`}`;
    } else if (now.isSame(messageDate, "week")) {
        return messageDate.format(dayTimeFormat);
    } else {
        return messageDate.format(
            userList ? userListDateFormat : chatDateTimeFormat
        );
    }
};

export const getWeekDays = (date) => {
    const startOfWeek = new Date(date);
    startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay()); // Start on Sunday
    return Array.from({ length: 7 }).map((_, i) => {
        const day = new Date(startOfWeek);
        day.setDate(startOfWeek.getDate() + i);
        return {
            date: day.toISOString().split("T")[0], // Format: YYYY-MM-DD
            weekday: day.toLocaleDateString("en-US", { weekday: "short" }), // "SUN"
            day: day.getDate(), // 23, 24, etc.
            month: day.toLocaleString("en-US", { month: "short" }), // "Mar"
            year: day.getFullYear(),
        };
    });
};



export const groupEventsByDate = (events, startDateStr, endDateStr) => {
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);
    const result = {};
    const normalizeDate = (date) => {
        const d = new Date(date);
        d.setHours(0, 0, 0, 0);
        return d;
    };
    for (
        let d = new Date(startDate);
        d <= endDate;
        d.setDate(d.getDate() + 1)
    ) {
        const currentDate = normalizeDate(d);
        const dateString = currentDate.toLocaleDateString("en-CA"); // Local date in YYYY-MM-DD
        const filteredEvents = events.filter((event) => {
            const eventStart = normalizeDate(new Date(event.start));
            const eventEnd = normalizeDate(new Date(event.end));
            return eventStart <= currentDate && eventEnd >= currentDate;
        });
        filteredEvents.sort((a, b) => new Date(a.start) - new Date(b.start));
        result[dateString] = filteredEvents;
    }
    return result;
};

// export const calculateLoanAmount = (price, downPayment) =>
//     Math.round(price * (1 - downPayment / 100));

export const LTV_CAP = {
    uae: 85,
    expat: 80,
    nonResident: 60,
};

export const calculateLoanAmount = (
    price,
    downPaymentPercent,
    residencyStatus
) => {
    const ltvCap = LTV_CAP[residencyStatus];

    const downPaymentAmount = price * (downPaymentPercent / 100);
    const loanAfterDownPayment = price - downPaymentAmount;
    const loanAllowedByLTV = price * (ltvCap / 100);

    return Math.round(Math.min(loanAfterDownPayment, loanAllowedByLTV));
};

export const calculateEMI = (loanAmount, interest, tenure) => {
    const r = interest / 12 / 100;
    const n = tenure * 12;
    if (!r || !n) return 0;

    return (loanAmount * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);
};

export const valueToPercent = (v) => {
    return v <= 20
        ? ((v - 0.5) / 20) * 50 // 1–20 → 0–50%
        : 50 + ((v - 20.5) / 4) * 50; // 21–25 → 50–100%
};

export const percentToValue = (p) => {
    return p < 50
        ? 1 + Math.min(Math.floor((p * 20) / 50), 19) // 0–50% → 1–20
        : 21 + Math.min(Math.floor(((p - 50) * 4) / 50), 4); // 50–100% → 21–25
};

export const downloadFile = (url, name = "download") => {
    if (!url) return;

    const a = document.createElement("a");
    a.href = url;
    a.download = name;
    // a.rel = "noopener noreferrer";
    // a.target = "_blank";
    document.body.appendChild(a);
    a.click();
    a.remove();
};

export const isEmptyPropertyResponse = (data) => {
    if (!data || typeof data !== "object") return true;

    return Object.values(data).every(
        (value) => value === null || value === "" || value === false
    );
};




export const expandEventsDaily = (events = []) => {
    const expanded = [];

    events.forEach((event) => {
        const startDate = event.bidding_start || event.start;
        const endDate = event.bidding_end || event.end;

        if (!startDate || !endDate) return;

        const start = moment(startDate).startOf("day");
        const end = moment(endDate).startOf("day"); // actual last day

        let current = start.clone();

        while (current.isSameOrBefore(end, "day")) {
            expanded.push({
                ...event,
                id: `${event.id}_${current.format("YYYYMMDD")}`,
                property_id: event.property_id || event.id, // important
                originalId: Number(event.id),
                start: current.toISOString(),
                end: current.clone().endOf("day").toISOString(),
                allDay: true,
            });

            current.add(1, "day");
        }
    });

    return expanded;
};

export const normalizeDailyEvents = (events = []) => {
    const expanded = [];

    events.forEach((event) => {
        if (!event.start || !event.end) return;

        const start = moment(event.start).startOf("day");

        // 🔑 SAME FIX HERE
        const end = moment(event.end).startOf("day").subtract(1, "day");

        let current = start.clone();

        while (current.isSameOrBefore(end, "day")) {
            expanded.push({
                ...event,
                id: `${event.id}_${current.format("YYYYMMDD")}`,
                originalId: Number(event.id),
                start: current.toDate(),
                end: current.clone().endOf("day").toDate(),
            });

            current.add(1, "day");
        }
    });

    return expanded;
};


export const filterEventsByWeekAndDay = (
    events = [],
    weekStart,
    weekEnd,
    selectedDay = null
) => {
    return events.filter(({ bidding_start, bidding_end }) => {
        if (!bidding_start || !bidding_end) return false;

        const start = moment(bidding_start).startOf("day");

        //  FIX: bidding_end is exclusive → make it inclusive
        const end = moment(bidding_end).startOf("day");

        //  WEEK FILTER
        const inWeek =
            end.isSameOrAfter(weekStart, "day") &&
            start.isSameOrBefore(weekEnd, "day");

        if (!inWeek) return false;

        //  DAY FILTER
        if (selectedDay) {
            return (
                start.isSameOrBefore(selectedDay, "day") &&
                end.isSameOrAfter(selectedDay, "day")
            );
        }

        return true;
    });
};


export const splitAndCombine = (number) => {
    const str = number.toString();
    const countryCode = str.slice(0, 3);
    const phoneNumber = str.slice(3);
    return {
        countryCode,
        phoneNumber,
        fullNumber: countryCode + phoneNumber
    };
}

export const makeFullName = (first, last) =>
    [first, last].filter(Boolean).join(' ');

export const splitFullName = (full = "") => {
    const [firstName, ...lastName] = full.trim().split(/\s+/);

    return {
        firstName: firstName || "",
        lastName: lastName.join(" "),
    };
}

// export const getLotFinancials = (lots = [], selectedLots = [], apiTotalDeposit = null) => {
//     if (!lots.length) {
//         return { totalDeposit: 0, minDeposit: 0 };
//     }

//     const selectedSet = new Set(selectedLots);
//     const hasSelection = selectedSet.size > 0;

//     let totalDeposit = 0;
//     let minDeposit = null;

//     for (const { id, deposit_amount } of lots) {
//         const deposit = Number(deposit_amount) || 0;

//         if (!hasSelection || selectedSet.has(id)) {
//             if (hasSelection) totalDeposit += deposit;

//             minDeposit = minDeposit === null
//                 ? deposit
//                 : Math.min(minDeposit, deposit);
//         }
//     }

//     minDeposit = minDeposit || 0;

//     if (!hasSelection) {
//         totalDeposit = minDeposit;
//     }

//     return {
//         totalDeposit: apiTotalDeposit ?? totalDeposit,
//         minDeposit: minDeposit || 0
//     };
// };

// export const getLotFinancials = (lots = [], selectedLots = [], BidMultiplier = 10) => {
//     if (!lots.length) {
//         return { totalDeposit: 0, biddingLimit: 0 };
//     }

//     const selectedSet = new Set(selectedLots.map(Number));
//     const hasSelection = selectedSet.size > 0;

//     let totalDeposit = 0;
//     let minDeposit = Infinity;

//     for (const { id, deposit_amount } of lots) {
//         const deposit = Number(deposit_amount);
//         if (isNaN(deposit)) continue;

//         // track min always
//         minDeposit = Math.min(minDeposit, deposit);

//         // sum selected
//         if (hasSelection && selectedSet.has(Number(id))) {
//             totalDeposit += deposit;
//         }
//     }

//     // fallback → no selection
//     if (!hasSelection) {
//         totalDeposit = minDeposit === Infinity ? 0 : minDeposit;
//     }

//     const biddingLimit = totalDeposit * BidMultiplier;

//     return {
//         totalDeposit,
//         biddingLimit,
//     };
// };

export const getLotFinancials = (
    lots = [],
    selectedLots = [],
    BidMultiplier = 10,
    saveData = {
        bidding_limit
            : 0,
        deposit_amount
            : 0
    }
) => {
    if (!lots.length) {
        return {
            totalDeposit: 0,
            biddingLimit: 0,
            minRequiredDeposit: 0,
            maxDepositAmount: 0,
        };
    }

    const selectedSet = new Set(selectedLots.map(Number));
    const hasSelection = selectedSet.size > 0;

    let totalDeposit = 0;
    let minDeposit = Infinity;
    let totalAllDeposits = 0;

    for (const { id, deposit_amount } of lots) {
        const deposit = Number(deposit_amount);
        if (isNaN(deposit)) continue;

        // track min deposit
        minDeposit = Math.min(minDeposit, deposit);

        // sum all deposits (for max calculation)
        totalAllDeposits += deposit;

        // sum selected deposits
        if (hasSelection && selectedSet.has(Number(id))) {
            totalDeposit += deposit;
        }
    }

    // fallback → no selection
    if (!hasSelection) {
        totalDeposit = minDeposit === Infinity ? 0 : minDeposit;
    }

    const biddingLimit = totalDeposit * BidMultiplier;

    // NEW LOGIC
    const minRequiredDeposit =
        // minDeposit === Infinity ? 0 : minDeposit * BidMultiplier;
        minDeposit === Infinity ? 0 : minDeposit;

    const maxDepositAmount = totalAllDeposits * BidMultiplier;

    const finalTotalDeposit =
        saveData?.deposit_amount > 0
            ? Number(saveData.deposit_amount)
            : totalDeposit;

    const finalBiddingLimit =
        saveData?.bidding_limit > 0
            ? Number(saveData.bidding_limit)
            : biddingLimit;

    return {
        totalDeposit: finalTotalDeposit,
        biddingLimit: finalBiddingLimit,
        minRequiredDeposit,
        maxDepositAmount,
        minRequiredDeposit,
        maxDepositAmount,
    };
};

// eMSigner redirects back into the same window it was opened from — an
// iframe (window.parent) or a fallback new tab (window.opener). Relay the
// redirect payload to whichever one applies so the original page's
// EmsignerIframe message listener can pick up the signing completion.
export const relayEmsignerCompletion = (data) => {
    const target = window.opener || window.parent;
    if (target === window) return;
    target.postMessage(data, window.location.origin);
    if (window.opener) window.close();
};
